<template>
  <div class="voice-recongnition-container">
    <div
      class="empty"
      v-if="listData.length === 0"
    >
      <img :src="imageError">
      <h6>此{{ labelName }}暂无语音识别信息</h6>
    </div>
    <div v-else>
      <div class="search-input">
        <el-input
          v-model.trim="searchText"
          placeholder="输入关键词搜索......"
          @keyup.enter.native="filterList"
          @input="highlightText"
        /><span @click="filterList"><i class="icon btn-search" /></span>
      </div>
      <el-timeline>
        <el-timeline-item
          placement="top"
          v-for="(item, index) in listData"
          :key="index"
          :timestamp="item.beginTime"
        >
          <div
            @click="setPlay(index, item.beginTime)"
            :class="[
              'txt',
              { active: currentPlayIndex === index },
              { highlight: inputVisible[item.id] }
            ]"
          >
            <p
              v-if="!inputVisible[item.id]"
              v-html="item.name"
            />
            <el-input
              v-model="item.editName"
              v-else
            />
            <i
              class="icon jlxk-audio-video-detail-alter"
              @click="handleShow(item)"
              v-show="!inputVisible[item.id]"
            />
            <i
              class="icon jlxk-video-detail-submit"
              v-show="inputVisible[item.id]"
              @click="handleSure(item, index)"
            />
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      searchText: '',
      videoError: require('@assets/imgs/jlxk/video-detail-error.png'),
      audioError: require('@assets/imgs/jlxk/audio-detail-error.png'),
      listData: [],
      inputVisible: {},
      sotreData: {},
      currentPlayIndex: null
    }
  },
  computed: {
    type() {
      return this.detail.type
    },
    isVideo() {
      return this.type === 'video'
    },
    labelName() {
      return this.isVideo ? '视频' : '音频'
    },
    imageError() {
      return this.isVideo ? this.videoError : this.audioError
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleInputVisible() {
      let visible = {}
      this.listData.forEach(item => {
        visible[item.id] = false
      })
      this.inputVisible = visible
    },
    handleShow(value) {
      this.inputVisible[value.id] = true
    },
    // 关键词检索
    filterList() {
      this.listData = this.sotreData.filter(
        sotreData => sotreData.name.indexOf(this.searchText) !== -1
      )
      this.highlightText()
    },
    // 输入匹配高亮字体
    highlightText() {
      this.listData = this.listData.map(item => {
        if (this.searchText === '') return Object.assign({}, item)
        let arr = item.name.split(this.searchText)
        return Object.assign({}, item, {
          name:
            arr.length > 1
              ? arr.join(
                '<span class="keywords-highlightyellow">' +
                    this.searchText +
                    '</span>'
              )
              : item.name
        })
      })
    },
    // 修改
    handleSure(value, index) {
      this.currentPlayIndex = index
      let alterIndex = this.sotreData.findIndex(item => item.id === value.id)
      this.$set(this.sotreData[alterIndex], 'name', value.editName)
      let result = []
      this.sotreData.forEach(item => {
        result.push(item.time + '\n' + item.name)
      })
      this.$emit('updateDetail', { flag: 'txt', content: result })
    },
    setPlay(index, time) {
      this.currentPlayIndex = index
      this.$emit('handlePlay', time)
    }
  },
  watch: {
    detail: {
      handler(newVal) {
        if (JSON.stringify(newVal) === '{}' || !newVal.txt) {
          this.listData = []
          return false
        }
        this.listData = newVal.txt.map((item, index) => {
          let result = item.split('\n')
          let time = result[0].split(' --> ')
          return {
            name: result[1],
            storeName: result[1],
            editName: result[1],
            beginTime: time[0].slice(0, 8),
            time: result[0],
            id: index
          }
        })
        this.sotreData = JSON.parse(JSON.stringify(this.listData))
        this.handleInputVisible()
      }
    },
    deep: true,
    immediate: true
  }
}
</script>

<style lang="scss" scoped>
.voice-recongnition-container {
  .search-input {
    display: flex;
    margin-top: 15px;
    /deep/ .el-input {
      &__inner {
        height: 30px;
        background: #ffffff;
        border-color: #ececec;
      }
    }
    span {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #4497ec;
      cursor: pointer;
    }
  }
  /deep/ .el-timeline {
    max-height: calc(100vh - 240px);
    overflow-y: auto;
    &-item {
      &__content {
        .txt {
          padding: 0 13px 0 15px;
          display: flex;
          justify-content: space-between;
          background: #f5f7f8;
          border-radius: 3px;
          min-height: 30px;
          align-items: center;
          &.active,&:hover {
            background: #ebeff2;
            p {
              color: #4497ec;
            }
          }
          &.highlight {
            height: 48px;
            padding: 9px;
            background-color: #f5f5f5;
          }
        }
        p {
          padding:5px 0;
          font-size: 12px;
          color: #666;
          .keywords-highlightyellow {
            background-color: yellow;
          }
        }
        .el-input {
          &__inner {
            width: 466px;
            background: #fff;
            height: 30px;
            line-height: 30px;
          }
        }
        i {
          flex-shrink: 0;
          visibility: hidden;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
